import { render, staticRenderFns } from "./performanceModal.vue?vue&type=template&id=4f95158b"
import script from "./performanceModal.vue?vue&type=script&lang=js"
export * from "./performanceModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports